export const EMPRESA_MODULOS = {
  catastro: {
    label: "Catastro de Entidades",
    desc: "Directorio unificado de clientes, proveedores y empleados con roles múltiples por entidad",
    permisos: ["empresas", "proveedores", "empleados", "localidades", "entidades", "configuracion_catastro"],
    obligatorio: true,
  },
  plan_cuentas: {
    label: "Plan de cuentas",
    desc: "Cuentas por cobrar y pagar para ventas/compras contado y crédito",
    permisos: ["plan_cuentas"],
    obligatorio: true,
    acciones: ["ver", "crear", "editar", "eliminar", "asignar_cuentas"],
  },
  ventas_base: {
    label: "Ventas base",
    desc: "Facturas, recibos/cobros de crédito y notas de crédito de ventas",
    // "vendedores" faltaba en esta lista (el backend en config.py SÍ lo tiene
    // dentro de ventas_base) — como este archivo es el que decide qué
    // permisos se pueden conceder en Usuarios según los módulos habilitados
    // de la empresa, vendedores.ver/crear/editar/eliminar nunca aparecían
    // como opción para asignar a ningún usuario, aunque el módulo existiera.
    permisos: ["facturas", "recibos", "notas_credito", "configuracion_ventas", "vendedores"],
  },
  pdv: {
    label: "PDV",
    desc: "Punto de venta rápido para facturación directa con productos, clientes, caja y stock",
    permisos: ["pdv"],
    permisos_minimos: [
      "pdv.ver",
      "pdv.operar",
      "facturas.crear",
      "inventario_productos.ver",
      "facturas.afectar_stock",
    ],
    permisos_recomendados: [
      "entidades.crear o empresas.crear para alta rápida de clientes",
      "pdv.configurar para encargados de configuración",
      "configuracion_ventas.gestionar_timbrado para configurar puntos de expedición",
    ],
  },
  presupuestos: {
    label: "Presupuestos",
    desc: "Presupuestos, costos estimados y vinculación con facturas",
    permisos: ["presupuestos", "costos"],
  },
  ingresos_varios: {
    label: "Ingresos sin factura",
    desc: "Ingresos directos sin emitir factura",
    permisos: ["ingresos_varios"],
  },
  egresos_base: {
    label: "Egresos base",
    desc: "Compras libres y gastos fijos/recurrentes",
    permisos: ["compras", "costos_fijos", "configuracion_egresos", "anticipos_proveedores"],
  },
  sueldos: {
    label: "Sueldos",
    desc: "Liquidación de sueldos, extras, adelantos y descuentos (gestión de empleados en Catastro)",
    permisos: ["sueldos"],
  },
  balance: {
    label: "Balance e IVA",
    desc: "Balance, tesorería, IVA fiscal y pagos de IVA",
    permisos: ["balance"],
  },
  inventario_tecnico: {
    label: "Inventario técnico",
    desc: "Activos técnicos, credenciales y alertas",
    permisos: ["inventario", "credenciales", "alertas"],
  },
  productos_stock: {
    label: "Productos y stock",
    desc: "Catálogo de productos, movimientos, historial de stock, categorías, subcategorías y atributos",
    permisos: ["inventario_productos", "historial_stock", "historial_costos", "unidades_medida", "configuracion_productos", "entregas"],
  },
  reportes: {
    label: "Reportes",
    desc: "Reportes imprimibles y exportables",
    permisos: ["reportes"],
  },
  administracion: {
    label: "Administración delegada",
    desc: "Usuarios y auditoría limitados a las empresas asignadas",
    permisos: ["usuarios", "auditoria", "configuracion_global"],
    obligatorio: true,
  },
  mensajes: {
    label: "Mensajes",
    desc: "Mensajes recibidos desde la web",
    permisos: ["mensajes"],
  },
  soporte: {
    label: "Soporte",
    desc: "Sistema de tickets de soporte con historial y seguimiento de incidencias",
    permisos: ["soporte"],
    obligatorio: true,
  },
  avisos: {
    label: "Avisos",
    desc: "Publicación de avisos e información importante para los usuarios de cada empresa",
    permisos: ["avisos"],
    obligatorio: true,
  },
  financiero: {
    label: "Financiero",
    desc: "Cuentas bancarias, transferencias, préstamos, pagos a proveedores y gestión financiera centralizada",
    permisos: ["transferencias", "bancos", "cotizaciones", "configuracion_financiero", "pagos_proveedores", "cheques", "prestamos"],
    obligatorio: true,
    acciones: ["ver", "crear", "editar", "eliminar", "historial"],
  },
  tipos_factura: {
    label: "Tipos de factura",
    desc: "Clasificación personalizada de facturas por categoría (ej: Proyecto, Garantía, Mantenimiento)",
    permisos: ["tipos_factura"],
  },
  lectura_bombas: {
    label: "Lectura de Bombas",
    desc: "Operación de pista de combustibles — apertura y cierre de turnos, historial y reportes",
    permisos: ["lectura_bombas"],
  },
  produccion: {
    label: "Producción",
    desc: "Módulo de cocina y producción — KDS, comandas, fichas técnicas, delivery y catálogos",
    permisos: ["produccion", "produccion_kds", "produccion_facturacion", "produccion_historial", "produccion_fichas", "produccion_configuracion"],
  },
  hoteleria: {
    label: "Hotelería",
    desc: "Módulo hotelero — panel de habitaciones, check-in/out, gastos, extracto y facturación de estadías",
    permisos: ["hoteleria"],
    // El check-out factura contra Ventas (facturas) — sin ese módulo no se puede cerrar una estadía.
    dependencias: ["ventas_base"],
  },
  loteadora: {
    label: "Loteadora",
    desc: "Módulo de gestión de lotes y fraccionamientos — mapa, reservas, ventas a cuotas y catastro SNC",
    permisos: ["loteadora"],
  },
  backup: {
    label: "BackUp de datos",
    desc: "Exportar e importar copias de seguridad encriptadas por empresa",
    permisos: ["backup"],
    obligatorio: true,
  },
  garantias: {
    label: "Garantías",
    desc: "Control de pagarés — garantías recibidas de clientes y concedidas a proveedores, con seguimiento de custodia y cobro",
    permisos: ["garantias"],
    acciones: ["ver", "emitir", "cobrar", "anular"],
  },
  licencias: {
    label: "Licencias",
    desc: "Autogestión de licencia: permite sumar 2 días de gracia una única vez si la licencia venció",
    permisos: ["licencias"],
    obligatorio: true,
    acciones: ["autoextender"],
  },
  transporte: {
    label: "Transporte",
    desc: "Control de flete — vehículos, choferes y emisión de Órdenes de Carga para el transporte de mercadería",
    permisos: ["transporte"],
    acciones: ["ver", "crear", "editar", "eliminar", "cambiar_estado", "imprimir_orden"],
  },
  restaurante: {
    label: "Restaurante",
    desc: "Tarjetas de comanda con código de barras y consumo por mesa — Salón, gestión de tarjetas y cobro integrado con PDV/Facturas",
    permisos: ["restaurante"],
    acciones: ["ver", "crear", "editar", "eliminar", "cerrar_cuenta", "generar_tarjetas"],
  },
  importaciones: {
    label: "Importaciones",
    desc: "Carpetas de importación: despacho aduanero, costeo (CIF, DIE, tasas, gastos locales), IVA crédito, nacionalización a depósito y reliquidación",
    permisos: ["importaciones"],
    acciones: ["ver", "crear", "editar", "eliminar", "liquidar", "nacionalizar", "reliquidar", "configurar", "ver_costos"],
    // Los gastos locales son compras y la nacionalización ingresa stock.
    dependencias: ["egresos_base", "productos_stock"],
  },
  bascula: {
    label: "Báscula",
    desc: "Registro de pesajes de granos (compra/venta) con descuentos de calidad configurables y vínculo a Facturas/Compras",
    permisos: ["bascula"],
    acciones: ["ver", "crear", "editar", "eliminar", "configurar_descuentos"],
    // Reutiliza choferes y vehículos ya cargados en Transporte — sin ese
    // módulo habilitado, Báscula no tiene de dónde sacarlos.
    dependencias: ["transporte"],
  },
  equipos_bascula: {
    label: "Configuración de Equipos / Báscula",
    desc: "Configuración de balanzas (serial / TCP-IP) y captura automática del peso en los pesajes de Báscula",
    permisos: ["equipos_bascula"],
    acciones: ["ver", "crear", "editar", "eliminar", "probar_captura", "gestionar_catalogos"],
    // Las balanzas alimentan los pesajes: sin Báscula no tienen uso.
    dependencias: ["bascula"],
  },
  recetario: {
    label: "Recetario agronómico",
    desc: "Receta / orden de aplicación obligatoria al vender productos controlados (agroquímicos): ingenieros, chacras por cliente y ficha agronómica del producto",
    permisos: ["recetario"],
    acciones: ["ver", "crear", "editar", "anular", "imprimir", "gestionar_ingenieros", "gestionar_chacras"],
    // La receta nace de la venta (Facturas/PDV) y de la ficha del producto.
    dependencias: ["ventas_base", "productos_stock"],
  },
  clinica: {
    label: "Clínica / Fisioterapia",
    desc: "Pacientes (ligados al Catastro), expediente clínico, agenda de turnos, profesionales, servicios, comisiones y liquidación de comisiones",
    permisos: ["clinica_agenda", "clinica_pacientes", "clinica_expediente", "clinica_configuracion", "clinica_liquidaciones", "clinica_reportes"],
    // Los servicios son productos del catálogo y los turnos atendidos se facturan en Ventas.
    dependencias: ["ventas_base", "productos_stock"],
  },
  constructora: {
    label: "Constructora",
    desc: "Proyectos de obra: cliente, contrato, plan de cobros, presupuesto, cronograma, compras/gastos, equipos, personal y facturación integrados por proyecto",
    permisos: ["constructora_proyectos", "constructora_configuracion", "constructora_presupuesto", "constructora_cronograma", "constructora_anticipos", "constructora_compras", "constructora_gastos", "constructora_equipos", "constructora_personal", "constructora_facturacion", "constructora_reportes"],
    acciones: ["ver", "crear", "editar", "eliminar", "cambiar_estado", "contrato_ver", "contrato_cargar", "plan_cobros", "gestionar_grupos", "importar", "vincular_factura", "reprogramar", "clima", "anular", "asignar", "pagar", "facturar"],
    // Factura al cliente (Ventas) y compras/gastos de la obra (Egresos).
    dependencias: ["ventas_base", "egresos_base"],
  },
};

export const DEFAULT_EMPRESA_MODULOS = Object.keys(EMPRESA_MODULOS);
export const EMPRESA_MODULOS_OBLIGATORIOS = Object.entries(EMPRESA_MODULOS)
  .filter(([, config]) => config.obligatorio)
  .map(([key]) => key);

// Dependencias duras entre módulos: si la clave está habilitada, todos los
// módulos de su lista también deben estarlo. Se define directamente en cada
// entrada de EMPRESA_MODULOS de arriba (campo "dependencias") — este mapa
// solo lo deriva para uso más cómodo. Convención general del sistema: al
// agregar un módulo que necesite de otro para funcionar, sumarle
// "dependencias: [...]" en su entrada (y espejarlo en backend/config.py,
// EMPRESA_MODULOS_DEPENDENCIAS).
export const EMPRESA_MODULOS_DEPENDENCIAS = Object.fromEntries(
  Object.entries(EMPRESA_MODULOS)
    .filter(([, config]) => config.dependencias?.length)
    .map(([key, config]) => [key, config.dependencias])
);

// Dado un array de módulos que se van a guardar, devuelve la lista de
// problemas encontrados (vacía si no hay ninguno). Cada problema trae el
// módulo, sus labels y los módulos que le faltan (con su label también),
// listo para armar un mensaje o una etiqueta en la UI.
export const validarDependenciasModulos = (modulosSeleccionados) => {
  const habilitados = new Set(modulosSeleccionados || []);
  const problemas = [];
  for (const [modulo, requeridos] of Object.entries(EMPRESA_MODULOS_DEPENDENCIAS)) {
    if (!habilitados.has(modulo)) continue;
    const faltantes = requeridos.filter(r => !habilitados.has(r));
    if (faltantes.length > 0) {
      problemas.push({
        modulo,
        moduloLabel: EMPRESA_MODULOS[modulo]?.label || modulo,
        faltantes,
        faltantesLabels: faltantes.map(f => EMPRESA_MODULOS[f]?.label || f),
      });
    }
  }
  return problemas;
};

export const PERMISO_A_MODULO_EMPRESA = Object.fromEntries(
  Object.entries(EMPRESA_MODULOS).flatMap(([moduloEmpresa, config]) =>
    config.permisos.map(permisoModulo => [permisoModulo, moduloEmpresa])
  )
);

export const moduloEmpresaDePermiso = (permiso) => {
  const permisoModulo = String(permiso || "").split(".")[0];
  return PERMISO_A_MODULO_EMPRESA[permisoModulo] || null;
};

export const modulosHabilitadosEmpresa = (empresaPropia) => {
  const modulos = empresaPropia?.modulos_habilitados;
  if (!Array.isArray(modulos)) return DEFAULT_EMPRESA_MODULOS;
  const legacyAliases = {
    // Módulos renombrados / fusionados — empresas con el valor viejo en DB siguen funcionando
    clientes: ["catastro"],       // "clientes" era módulo obligatorio → ahora es "catastro"
    proveedores: ["catastro"],    // "proveedores" era módulo opcional → absorbido en catastro
    ventas: ["ventas_base", "presupuestos", "ingresos_varios"],
    facturas: ["ventas_base"],
    recibos: ["ventas_base"],
    notas_credito: ["ventas_base"],
    egresos: ["egresos_base", "sueldos", "balance"],
    compras: ["egresos_base"],
    gastos: ["egresos_base"],
    pagos_proveedores: ["financiero"],
  };
  return [...new Set([
    ...EMPRESA_MODULOS_OBLIGATORIOS,
    ...modulos.flatMap(m => legacyAliases[m] || [m]),
  ])];
};

export const empresaTieneModulo = (empresaPropia, modulo) => {
  if (!empresaPropia || !modulo) return true;
  return modulosHabilitadosEmpresa(empresaPropia).includes(modulo);
};

export const permisoHabilitadoPorEmpresa = (empresaPropia, permiso) => {
  const modulo = moduloEmpresaDePermiso(permiso);
  return !modulo || empresaTieneModulo(empresaPropia, modulo);
};
